import * as formatTypes from './formatTypes';
import { parse, format, isValid } from 'date-fns';

export const dateParser = (val) => {
  if (val === undefined || val === null) return;

  let parsed = parse(val, 'M/d/yyyy', new Date());

  return isValid(parsed) ? format(parsed, 'MM/dd/yyyy') : val;
};

export const currencyParser = (val) => {
  if (val === undefined || val === null) return;
  val = roundedValue(val, '$');
  // PHX-5415: integers are sometimes being passed, so need to cast to string
  return String(val).replace(/\D/g, '');
};

export const phoneParser = (val) => {
  if (val === undefined || val === null) return;

  return val.replace(/\D/g, '');
};

export const ssnDashParser = (val) => {
  if (val === undefined || val === null) return;

  return val.replace(/\D/g, '');
};

export const percentParcer = (val) => {
  if (val === undefined || val === null) return;

  return val.replace('%', '');
};

// PHX-3669: Number parser, when not a float
export const numberParser = (val) => {
  if (
    val === undefined ||
    val === null ||
    (typeof val === 'string' && !val?.trim())
  )
    return;

  if (typeof val === 'number') return val;

  if (!Number.isInteger(val)) {
    val = Math.round(val).toString();
  }

  return val.replace(/\D/g, '');
};

export const specialCharacterParser = (event) => {
  const regex = new RegExp("^[a-zA-Z0-9, '()-.]+$");
  const key = String.fromCharCode(
    !event.charCode ? event.which : event.charCode
  );
  if (event.which !== 13 && !regex.test(key)) {
    event.preventDefault();
    return false;
  }
};

const numberWithCommasParser = (val) => {
  if (val === undefined || val === null) return;
  val = roundedValue(val, ',');

  return val.toString().replace(/\D/g, '');
};

export const getParser = (type, isDecimalAllowed = false) => {
  switch (type) {
    case formatTypes.DOB:
    case formatTypes.DATE:
      return dateParser;
    case formatTypes.CURRENCY:
      return isDecimalAllowed ? decimalCurrencyParser : currencyParser;
    case formatTypes.PERCENT:
      return percentParcer;
    case formatTypes.PHONE:
      return phoneParser;
    case formatTypes.SSN:
      return ssnDashParser;
    case formatTypes.NUMBER:
      return isDecimalAllowed ? undefined : numberParser;
    case formatTypes.NUMBERWITHCOMMAS:
      return numberWithCommasParser;
    default:
      break;
  }
};

// PHX-5185: Decimal values are rounded to the nearest integer
const roundedValue = (val, specialChar) => {
  // Validate input null, undefined, or empty strings
  if (val == null || (typeof val === 'string' && val.trim() === '')) {
    return '';
  }

  // Return integer values directly
  if (Number.isInteger(val)) {
    return val;
  }

  // Handle string values containing the special character
  if (typeof val === 'string' && val.includes(specialChar)) {
    if (val.length === 1) {
      return '';
    }
    val = Math.round(String(val).replace(/\D/g, ''));
  } else {
    val = Math.round(val);
  }

  return val;
};

export const decimalCurrencyParser = (val) => {
  if (val === undefined || val === null) return;

  if (typeof val === 'string') {
    val = val.replace(/[$,]/g, ''); // Remove currency symbols and commas

    // Return early if the string is just a negative sign or a decimal point
    if (/^[-.]?$/.test(val)) return val;

    return val; // Return the cleaned string
  }
  return String(val); // Convert non-string values to string
};
